<template>
  <TheMainContent>
    <RevContainer class="py-24">
      <div class="mx-auto max-w-[640px] space-y-32">
        <template v-if="isSubmissionSuccessful">
          <h1
            ref="successHeading"
            class="text-static-default-hi heading-1"
            tabindex="-1"
          >
            {{ i18n(translations.successTitle) }}
          </h1>
          <p class="body-1 text-static-default-low">
            {{ i18n(translations.successDescription) }}
          </p>
        </template>
        <template v-else>
          <h1 class="text-static-default-hi heading-1">
            {{ i18n(translations.title) }}
          </h1>

          <div class="space-y-12">
            <p class="body-1 text-static-default-low">
              {{ i18n(translations.descriptionIntro) }}
            </p>
            <p class="body-1 text-static-default-low">
              {{ i18n(translations.descriptionInstruction) }}
            </p>
          </div>

          <RevInfoBlock
            :content="i18n(translations.infoBlockContent)"
            :cta="i18n(translations.infoBlockCta)"
            :icon="IconInfo"
            :title="i18n(translations.infoBlockTitle)"
            variant="info"
            @click="goToOrders"
          />

          <ReportIllicitContentForm @success="handleSuccess" />
        </template>
      </div>
    </RevContainer>
  </TheMainContent>
</template>

<script lang="ts" setup>
import { navigateTo, useHead } from '#imports'
import { nextTick, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconInfo } from '@ds/icons/IconInfo'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'
import { ROUTE_NAMES } from '~/scopes/dashboard/constants'

import translations from './ReportIllicitContent.translations'
import ReportIllicitContentForm from './components/ReportIllicitContentForm/ReportIllicitContentForm.vue'

const i18n = useI18n()
const isSubmissionSuccessful = ref(false)
const successHeading = ref<HTMLHeadingElement | null>(null)

useHead({
  meta: [{ name: 'robots', content: 'noindex' }],
})

function goToOrders() {
  navigateTo({ name: ROUTE_NAMES.DASHBOARD.MY_ORDERS.SELF })
}

async function handleSuccess() {
  isSubmissionSuccessful.value = true
  await nextTick()
  successHeading.value?.focus()
}
</script>
